import { HouseSimple } from '@phosphor-icons/react';

export default HouseSimple;
